import { countryCodes } from '../data/countryCodes';

export function formatPhoneDisplay(digits: string): string {
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function getDialCode(countryCode: string): string {
  return (
    countryCodes.find((c) => c.code === countryCode)?.dial_code ??
    countryCodes.find((c) => c.code === 'US')?.dial_code ??
    '+1'
  );
}

export function formatFullPhone(countryCode: string, digits: string): string {
  if (!digits) return '';
  return `${getDialCode(countryCode)} ${formatPhoneDisplay(digits)}`;
}

export function parsePhoneDigits(value: string): string {
  return value.replace(/[^\d]/g, '').slice(0, 10);
}

export function isValidLocalPhone(digits: string): boolean {
  return /^\d{10}$/.test(digits);
}
